import {API_URL, SOCKET} from "../URL";
import {
    SET_SELECT_IMAGE,
    SET_SHOW_FORM,
    SET_TITLE
} from "../store/reducers/BoardCreate/constants";
import {CREATE_BOARD, EDIT_BOARD} from "../store/constants";

export const handleCreateBoard = async (
    e,
    selectedColor,
    title,
    user,
    selectedImage,
    boards,
    dispatch,
    isEdit,
    activeBoard
) => {
    e.preventDefault();

    if (!title.trim()) return;

    const backgroundData = {};

    if (selectedImage?.object_type_id === 6) {
        backgroundData.background_image_id = selectedImage.object_id;
    } else if (selectedImage?.id) {
        backgroundData.board_style_id = selectedImage.id;
    }

    if (selectedColor?.id) {
        backgroundData.color = selectedColor.id;
    }

    const newBoard = {
        name: title.trim(),
        user_id: user.id,
        created_at: Date.now(),
        ...backgroundData
    };

    if (!isEdit) {
        const res = await fetch(API_URL + "/post/create_board/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(newBoard),
        });

        const data = await res.json();

        dispatch({
            type: CREATE_BOARD,
            payload: data
        });

        SOCKET.emit("create_board", data);
    } else {
        const res = await fetch(API_URL + "/post/change_board/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
                id: activeBoard?.id,
                title: title.trim(),
                ...backgroundData
            }),
        });

        const data = await res.json();

        dispatch({
            type: EDIT_BOARD,
            payload: data,
        });

        SOCKET.emit("change_board", {
            data,
        });
    }

    dispatch({type: SET_TITLE, payload: ""});
    dispatch({type: SET_SELECT_IMAGE, payload: null});
    dispatch({type: SET_SHOW_FORM, payload: false});
};